import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../../interfaces/base";
import { IFetchDashboardRevenuesState } from "../../../../interfaces/store/dashboard-interface";

const initialState: IFetchDashboardRevenuesState = {
  revenues: [],
  sixMonthsRevenues: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
};

const _getRevenuesStart = (
  state: IFetchDashboardRevenuesState,
  { payload }: PayloadAction<any>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getRevenuesSuccess = (
  state: IFetchDashboardRevenuesState,
  { payload }: PayloadAction<any>
) => {
  state.revenues = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getSixMonthsRevenuesSuccess = (
  state: IFetchDashboardRevenuesState,
  { payload }: PayloadAction<any>
) => {
  state.sixMonthsRevenues = payload.data.data;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getRevenuesFailed = (
  state: IFetchDashboardRevenuesState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetSixMonthsRevenuesRevenues = (
  state: IFetchDashboardRevenuesState
) => {
  state.sixMonthsRevenues = [];
  state.loading = false;
  state.error = null;
};

const _resetDashboarIncomeHistory = (state: IFetchDashboardRevenuesState) => {
  state.revenues = [];
  state.loading = false;
  state.error = null;
};

const DashboardRevenuesSlice = createSlice({
  name: "dashboardRevenues",
  initialState,
  reducers: {
    getRevenuesStart: _getRevenuesStart,
    getRevenuesSuccess: _getRevenuesSuccess,
    getRevenuesFailed: _getRevenuesFailed,
    getSixMonthsRevenuesSuccess: _getSixMonthsRevenuesSuccess,
    resetIncomeHistory: _resetDashboarIncomeHistory,
    resetDashboardSixMonthsRevenues: _resetSixMonthsRevenuesRevenues,
  },
});

export const {
  getRevenuesStart,
  getRevenuesSuccess,
  getRevenuesFailed,
  getSixMonthsRevenuesSuccess,
  resetIncomeHistory,
  resetDashboardSixMonthsRevenues,
} = DashboardRevenuesSlice.actions;
export default DashboardRevenuesSlice.reducer;
